import LaunchIcon from "@mui/icons-material/Launch";
import { Box, Grid, Typography } from "@mui/material";
import MainCard from "components/MainCard";
// material-ui
import Stack from "@mui/material/Stack";

// project import
import Avatar from "components/@extended/Avatar";

//asset
import { useNavigate } from "react-router-dom";
import {
  CheckSquareOutlined,
  ContainerFilled,
  ReconciliationFilled,
  UsergroupAddOutlined,
} from "@ant-design/icons";
import useAuth from "hooks/useAuth";

const LinkCards = () => {
  const navigate = useNavigate();
  const { modules } = useAuth();

  const canAddMember = modules?.member.permissions.Add;
  const canAddEvent = modules?.event.permissions.Add;
  const canAddNews = modules?.news.permissions.Add;
  const canAddTestimonial = modules?.testimonial.permissions.Add;
  const canViewJobPosting = modules?.jobPosting.permissions.View;

  const hasAnyQuickLink =
    canAddMember ||
    canAddEvent ||
    canAddNews ||
    canAddTestimonial ||
    canViewJobPosting;

  if (!hasAnyQuickLink) return null;

  return (
    <>
      <Grid container spacing={1.2}>
        {canAddMember && (
          <Grid item xs={12} md={12} sm={12} lg={12} xl={12}>
            <MainCard boxShadow content={false}>
              <Stack
                alignItems="center"
                spacing={2}
                onClick={() => {
                  window.open("/member/add", "_blank", "noopener,noreferrer");
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    width: "100%",
                    padding: "10px 15px",
                    cursor: "pointer",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      gap: "10px",
                      alignItems: "center",
                    }}
                  >
                    <Avatar size="sm" type="filled">
                      <UsergroupAddOutlined />
                    </Avatar>
                    <Typography
                      sx={{
                        fontSize: { xs: 12, sm: 9, md: 11, lg: 13, xl: 14 },
                      }}
                      whiteSpace={"nowrap"}
                      variant="subtitle1"
                      color="secondary"
                    >
                      Create Member
                    </Typography>
                  </Box>
                  <Box>
                    <LaunchIcon
                      sx={{
                        fontSize: { xs: 21, sm: 20, md: 20, lg: 22, xl: 25 },
                      }}
                      color="secondary"
                    />
                  </Box>
                </Box>
              </Stack>
            </MainCard>
          </Grid>
        )}
        {canAddEvent && (
          <Grid item xs={12} md={12} sm={12} lg={12} xl={12}>
            <MainCard boxShadow content={false}>
              <Stack
                alignItems="center"
                spacing={2}
                onClick={() => {
                  window.open("/events/add", "_blank", "noopener,noreferrer");
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    width: "100%",
                    padding: "10px 15px",
                    cursor: "pointer",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      gap: "10px",
                      alignItems: "center",
                    }}
                  >
                    <Avatar size="sm" type="filled" color="info">
                      <ReconciliationFilled />
                    </Avatar>
                    <Typography
                      sx={{
                        fontSize: { xs: 12, sm: 9, md: 11, lg: 13, xl: 14 },
                      }}
                      whiteSpace={"nowrap"}
                      variant="subtitle1"
                      color="secondary"
                    >
                      Create Event
                    </Typography>
                  </Box>
                  <Box>
                    <LaunchIcon
                      sx={{
                        fontSize: { xs: 21, sm: 20, md: 20, lg: 22, xl: 25 },
                      }}
                      color="secondary"
                    />
                  </Box>
                </Box>
              </Stack>
            </MainCard>
          </Grid>
        )}
        {canAddNews && (
          <Grid item xs={12} md={12} sm={12} lg={12} xl={12}>
            <MainCard boxShadow content={false}>
              <Stack
                alignItems="center"
                spacing={2}
                onClick={() => {
                  window.open("/news/add", "_blank", "noopener,noreferrer");
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    width: "100%",
                    padding: "10px 15px",
                    cursor: "pointer",
                    fontSize: { xs: 5, sm: 5, md: 11, lg: 13, xl: 14 },
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      gap: "10px",
                      alignItems: "center",
                    }}
                  >
                    <Avatar size="sm" type="filled" color="success">
                      <ContainerFilled />
                    </Avatar>
                    <Typography
                      sx={{
                        fontSize: { xs: 12, sm: 9, md: 11, lg: 13, xl: 14 },
                      }}
                      whiteSpace={"nowrap"}
                      variant="subtitle1"
                      color="secondary"
                    >
                      Create News
                    </Typography>
                  </Box>
                  <Box>
                    <LaunchIcon
                      sx={{
                        fontSize: { xs: 21, sm: 20, md: 20, lg: 22, xl: 25 },
                      }}
                      color="secondary"
                    />
                  </Box>
                </Box>
              </Stack>
            </MainCard>
          </Grid>
        )}
        {canAddTestimonial && (
          <Grid item xs={12} md={12} sm={12} lg={12} xl={12}>
            <MainCard boxShadow content={false}>
              <Stack
                alignItems="center"
                spacing={2}
                onClick={() => {
                  window.open(
                    "/testimonial/add",
                    "_blank",
                    "noopener,noreferrer",
                  );
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    width: "100%",
                    padding: "10px 15px",
                    cursor: "pointer",
                    fontSize: { xs: 5, sm: 5, md: 11, lg: 13, xl: 14 },
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      gap: "10px",
                      alignItems: "center",
                    }}
                  >
                    <Avatar size="sm" type="filled" color="warning">
                      {/* <HourglassFilled /> */}
                      <UsergroupAddOutlined style={{ fontSize: "22px" }} />
                    </Avatar>
                    <Typography
                      sx={{
                        fontSize: { xs: 12, sm: 9, md: 11, lg: 13, xl: 14 },
                      }}
                      whiteSpace={"nowrap"}
                      variant="subtitle1"
                      color="secondary"
                    >
                      Create Testimonial
                    </Typography>
                  </Box>
                  <Box>
                    <LaunchIcon
                      sx={{
                        fontSize: { xs: 21, sm: 20, md: 20, lg: 22, xl: 25 },
                      }}
                      color="secondary"
                    />
                  </Box>
                </Box>
              </Stack>
            </MainCard>
          </Grid>
        )}
        {canViewJobPosting && (
          <Grid item xs={12} md={12} sm={12} lg={12} xl={12}>
            <MainCard boxShadow content={false}>
              <Stack
                alignItems="center"
                spacing={2}
                // onClick={() => {
                //   navigate("prominentMember/add");
                // }}
                onClick={() => {
                  window.open("/jobPosting", "_blank", "noopener,noreferrer");
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    width: "100%",
                    padding: "10px 15px",
                    cursor: "pointer",
                    fontSize: { xs: 5, sm: 5, md: 11, lg: 13, xl: 14 },
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      gap: "10px",
                      alignItems: "center",
                    }}
                  >
                    <Avatar size="sm" type="filled" color="secondary">
                      <CheckSquareOutlined />
                    </Avatar>
                    <Typography
                      sx={{
                        fontSize: { xs: 12, sm: 9, md: 11, lg: 13, xl: 14 },
                      }}
                      whiteSpace={"nowrap"}
                      variant="subtitle1"
                      color="secondary"
                    >
                      Approve Jobs
                    </Typography>
                  </Box>
                  <Box>
                    <LaunchIcon
                      sx={{
                        fontSize: { xs: 21, sm: 20, md: 20, lg: 22, xl: 25 },
                      }}
                      color="secondary"
                    />
                  </Box>
                </Box>
              </Stack>
            </MainCard>
          </Grid>
        )}
      </Grid>
    </>
  );
};
export default LinkCards;
